module.exports = __webpack_public_path__ + "html/random-feedback_3cd57d5b19b12f69c35e92ef71781ca5.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/random-feedback.html
// module id = TNnD
// module chunks = 5